export const SET_DARK_MODE = 'SET_DARK_MODE';
export const AUTH_LOADING = 'AUTH_LOADING';
export const SET_USER = 'SET_USER';
export const DATA_LOADING = 'DATA_LOADING';

export const SET_MEDICINES = 'SET_MEDICINES';
export const SET_USER_MEDICINES = 'SET_USER_MEDICINES';
export const ADD_MEDICINE = 'ADD_MEDICINE';
export const DELETE_MEDICINE = 'DELETE_MEDICINE';

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SET_RENDERABLE_MEDICINES = 'SET_RENDERABLE_MEDICINES';

export const SET_USER_INVOICES = 'SET_USER_INVOICES';
export const SET_SINGLE_INVOICE = 'SET_SINGLE_INVOICE';
export const ADD_INVOICE = 'ADD_INVOICE';
export const DELETE_MEDICINE_FROM_INVOICE = 'DELETE_MEDICINE_FROM_INVOICE';
